import AppApiConfig from 'assets/config/AppApiConfig'

// Allow live URL in debug mode (REACT_APP_ENV === 'develop')
// const isDebugMode = process.env.REACT_APP_ENV === 'develop'
const isLocalhost = window.location.hostname === 'localhost'

export const BASE_URL = isLocalhost
  ? `${AppApiConfig.API_ENDPOINT}${AppApiConfig.API_ADMIN_ENDPOINT}/`
  : process.env.REACT_APP_BACKEND_URL

// export const BASE_URL = process.env.REACT_APP_BACKEND_URL
